<template>
    <be-loading :active="loading">

        <div class="email-head">
            <div class="email-head-title">
                {{$route.meta.title}}
                <span class="icon mdi mdi-edit" v-if="editing"></span>
                <span class="icon mdi mdi-plus-box" v-else></span>
            </div>
        </div>

        <form @submit.prevent="submit">
            <slot/>

            <div class="email-compose-fields">
                <be-form-group class="text-right" horizontal>
                    <submit-button h-space v-if="editing">Änderungen speichern</submit-button>
                    <submit-button h-space v-else>Hinzufügen</submit-button>
                    <submit-button type="button" color="secondary" @click="$emit('cancel')">Abbrechen</submit-button>
                </be-form-group>
            </div>
        </form>
    </be-loading>
</template>

<script>
    export default {
        props: {
            loading: Boolean,
            editing: Boolean,
        },

        methods: {
            submit() {
                this.$emit('submit');
            },
        },
    };
</script>
